import API from './config'

export const AssetsAPI = {

    async getAllAssetsClient(clientId, fundId, regimeId, accountId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/assets/getAllAssetsClient?client_id=${clientId}&fund_id=${fundId}&regime_id=${regimeId}&account_id=${accountId}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getFundAssetsByInit(clientId, init) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/assets/getFundAssetsByInit?client_id=${clientId}&init=${init}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getTitlesAssetsByInit(clientId, init) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/assets/getTitlesAssetsByInit?client_id=${clientId}&init=${init}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async updateFundAssetInit(assetId, newInit) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put(`/assets/updateFundAssetInit`, {
                asset_id: assetId,
                new_init: newInit,
            }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async updateTitleAssetInit(assetId, newInit) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put(`/assets/updateTitleAssetInit`, {
                asset_id: assetId,
                new_init: newInit,
            }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getSimpleNormalizedAssets(clientId, month, year, accountRegimeId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const { data: response } = await API.get(`/assets/getSimpleNormalizedAssets?`
                + `client_id=${clientId}`
                + `&month=${month}`
                + `&year=${year}`
                + (accountRegimeId ? `&account_regime_id=${accountRegimeId}` : ""),
                config)

            return {
                success: true,
                ...response
            };

        } catch (error) {

            console.log("Error: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }
    },

}